import FromAmount from './fromAmount';

export default FromAmount;
